<template>
    <v-col cols="11" md='6' class="pb-0 pl-0">
      <h1 class="mb-8 mt-1">LCD Настройки</h1>
      <v-row>
        <v-col cols="12" sm="10" md="8" lg="6" class="py-0">
          <v-autocomplete
            ref="textDoor"
            flat
            :items="LCD"
            v-model='LCDSetting'
            item-text="type"
            item-value="welcome_display"
            label="Заставка"
            outlined
            dense
          ></v-autocomplete>
        </v-col>
        <v-col class="py-0">
          <v-btn
            color="success"
            class="text-none"
            dark
            @click="save"
          >
            Сохранить
          </v-btn>
        </v-col>
        <v-col v-if="displayMassage" cols="8" class="py-0">
          <v-text-field
            label="Сообщение"
            v-model='formData.massage'
            :rules="rules.massages"
            counter="50"
            outlined
            dense
            flat
            required
          ></v-text-field>
        </v-col>
        <v-col v-if="displayImg" cols="8" class="py-0">
          <v-file-input
            v-model='image'
            ref="image"
            accept=".bmp"
            outlined
            hint="Формат файла bmp, 320х200 пикселей, 256 цветов"
            persistent-hint
            dense
            flat
            label="Изображение"
          >
          </v-file-input>
        </v-col>
      </v-row>
    </v-col>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { LCD, rules } from '../consts';

export default {
  name: 'LCDSettings',
  data: () => ({
    response: [],
    LCDSetting: '',
    formData: {
      massage: '',
    },
    massage: '',
    image: null,
    rules,
    LCD,
  }),
  created () {
    this.getSettings();
  },
  computed: {
    ...mapGetters({
      doorphone: 'Doorphone/doorphoneEditDoorphone',
      doorphoneEditInfo: 'doorphone/doorphoneEditInfo',
    }),
    displayMassage () {
      return this.LCDSetting === 1;
    },
    displayImg () {
      return this.LCDSetting === 3;
    },
  },
  methods: {
    ...mapActions({
      viewLCDSettings: 'Doorphone/viewLCDSettings',
      editLCDSettings: 'Doorphone/editLCDSettings',
    }),
    returnDoorphone () {
      this.$router.push({ name: 'DetailDoorphone', params: { id: this.$route.params.id } });
    },
    assignment (data) {
      this.formData.massage = data.message;
      this.LCDSetting = data.welcome_display;
    },
    getSettings () {
      this.viewLCDSettings(this.$route.params.id)
        .then((data) => {
          this.response = data;
          this.assignment(data);
        })
        .catch((e) => {
          console.error(e);
          this.$flash_warning('Не удалось получить настройки');
        });
    },
    save () {
      const formData = new FormData();
      if (this.LCDSetting === 1) {
        formData.append('message', this.formData.massage);
      }
      if (this.LCDSetting === 3) {
        formData.append('image', this.image);
      }
      formData.append('welcome_display', this.LCDSetting);

      this.editLCDSettings({
        id: this.$route.params.id,
        formData,
      })
        .then(() => {
          this.$flash_success('Изменения успешно сохранены');
        })
        .catch(() => {
          this.$flash_warning('Ошибка сохранения LCD');
        });
    },
  },
};
</script>
